package org.chiangmeng.qfast.core.util

import kotlin.js.Date

actual fun getCurrentTimeString(): String {
    val d = Date()
    val h = d.getHours().toString().padStart(2, '0')
    val m = d.getMinutes().toString().padStart(2, '0')
    return "$h:$m"
}

actual fun getCurrentEpochMillis(): Long = Date.now().toLong()
